import { graphql, navigate, useStaticQuery } from 'gatsby';
import React from 'react';
import SignUpButton from 'src/components/SignUpButton';
import { socialLinks } from 'src/config';
import { RichText, SvgImage } from 'src/helpers';
import Analytics from 'src/helpers/analytics';
import {
  ContactUsContainer,
  ContactUsContent,
  ContactUsDescription,
  ContactUsJonniImage,
  ContactUsSignUpButtons,
  ContactUsTextContent,
  ContactUsTitle,
} from 'src/styles/homePage';

const descriptionActivityTimesStyles = { marginTop: 16, fontWeight: '700' };

const ContactUs: React.FC = () => {
  const {
    allContentfulFooter: { edges },
  } = useStaticQuery(graphql`
    query ContactUsJonniImageQuery {
      allContentfulFooter {
        edges {
          node {
            footerJonni {
              svg {
                content: originalContent
              }
              file {
                contentType
              }
            }
            footerTitle
            contactUsDescription {
              raw
            }
            contactUsActivityTimes {
              raw
            }
          }
        }
      }
    }
  `);

  const { footerJonni, footerTitle, contactUsDescription, contactUsActivityTimes } = edges[0].node;

  const onAppClick = (name: string) => {
    Analytics.logAppButtonClick(name);
    navigate(socialLinks.whatsapp!);
  };

  return (
    <ContactUsContainer>
      <ContactUsContent>
        <ContactUsJonniImage>
          <SvgImage {...footerJonni} />
        </ContactUsJonniImage>
        <ContactUsTextContent>
          <ContactUsTitle>{footerTitle}</ContactUsTitle>
          <ContactUsDescription>
            <RichText content={contactUsDescription} />
          </ContactUsDescription>
          <ContactUsDescription style={descriptionActivityTimesStyles}>
            <RichText content={contactUsActivityTimes} />
          </ContactUsDescription>
          <ContactUsSignUpButtons>
            <SignUpButton borderColor="blue" inverted onClick={() => onAppClick('whatsapp')} title={'פנייה בווטסאפ'} />
          </ContactUsSignUpButtons>
        </ContactUsTextContent>
      </ContactUsContent>
    </ContactUsContainer>
  );
};

export default ContactUs;
